// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"BlockedLinkAlert_alertWrapper__Qyhhm"};